// src/services/api/productSearch.js
import { apiClient } from './base';

export const getShopProducts = async (params = {}) => {
  try {
    const response = await apiClient.get('/product-search/shop-products', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShopProductVariations = async (productId, params = {}) => {
  try {
    const response = await apiClient.get(`/product-search/shop-products/${productId}/variations`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchProducts = async (shopId, searchTerm, options = {}) => {
  try {
    const params = {
      shopId,
      search: searchTerm,
      limit: options.limit || 10,
      page: options.page || 1,
      ...options
    };
    const response = await apiClient.get('/product-search/shop-products', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProducts = async (params) => {
  const response = await apiClient.get('/product-search', { params });
  return response.data;
};

export const getProductVariations = async (productId) => {
  const response = await apiClient.get(`/product-search/${productId}/variations`);
  return response.data;
};